import { Tokens as e } from "./atoms-v257.js";
const i = new e(), t = new e({
  tokens: {
    background: {
      light: {
        // Page background.
        default: "rgb(20 20 20)",
        // SearchParameter hover background.
        hover: "rgb(67, 67, 67)",
        inverse: "black",
        // SearchParameter background.
        layer01: "rgb(37, 37, 37)",
        layer02: "rgb(42 42 42)"
      }
    },
    body: {
      "compact-expressive": {
        fontFamily: 'Menlo, Futura, Georgia, Operator, "Ringside Regular SSm", serif',
        fontSize: 16,
        fontWeight: 300
      },
      // Button text style.
      "compact-productive": {
        fontFamily: 'Menlo, Futura, Georgia, Operator, "Ringside Regular SSm", serif',
        fontSize: 14,
        fontWeight: 500
      },
      // SearchParameter label style.
      expressive: {
        fontFamily: 'Menlo, Futura, Georgia, Operator, "Ringside Wide SSm", serif',
        fontSize: 16,
        fontWeight: 400
      }
    },
    border: {
      light: {
        main: "rgb(255 255 255/0.1)"
      }
    },
    colors: {
      white: "rgb(54, 54, 54)"
    },
    heading: {
      // Subtitle and SearchParameter values.
      "03": {
        fontFamily: 'Menlo, Futura, Georgia, Operator, "Ringside Narrow SSm", serif',
        fontSize: 22,
        fontWeight: 300,
        marginTop: "16px"
      },
      // Main heading.
      "06": {
        fontFamily: "Menlo, Futura, Georgia, Operator, serif",
        fontSize: 60,
        fontWeight: 300,
        letterSpacing: -2,
        lineHeight: 60,
        wordSpacing: "100vw"
      }
    },
    radius: {
      // Button border-radius.
      buttonText: 0,
      // SearchParameter border-radius.
      layerBorder: 1
    },
    text: {
      light: {
        disabled: "rgb(255 255 255/0.1)",
        primary: {
          // Page text color.
          default: "rgb(251, 251, 251)"
        }
      }
    }
  },
  ui: {
    // Button background colors.
    button: {
      light: {
        background: {
          active: "rgb(61, 96, 246)",
          default: "rgb(61, 96, 246)",
          hover: "rgb(31, 66, 216)"
        }
      }
    },
    field: {
      light: {
        background: {
          default: "rgb(37, 37, 37)",
          hover: "rgb(67, 67, 67)"
        }
      }
    },
    misc: {
      light: {
        focus: {
          // SearchParameter focus outline.
          default: "rgb(61, 96, 246)"
        }
      }
    },
    searchParameter: {
      queries: {
        large: { borderRadius: 0 },
        max: { borderRadius: 0 },
        medium: { borderRadius: 0 },
        small: { borderRadius: 0 }
      }
    }
  }
}), a = new e({
  tokens: {
    background: {
      light: {
        default: "white",
        hover: "rgb(236, 214, 225)",
        inverse: "rgb(244, 190, 216)",
        layer01: "rgb(252, 229, 240)",
        layer02: "rgb(253 229 241)"
      }
    },
    body: {
      "compact-expressive": {
        fontFamily: "Futura, sans-serif",
        fontSize: 16,
        fontWeight: 500
      },
      "compact-productive": {
        fontFamily: "Futura, sans-serif",
        fontSize: 14
      },
      expressive: {
        fontFamily: "Futura, sans-serif",
        fontWeight: 400
      }
    },
    border: {
      light: {
        main: "rgb(219 40 127/0.3)"
      }
    },
    heading: {
      "03": {
        fontFamily: "Futura, sans-serif",
        fontSize: 20,
        lineHeight: 30
      },
      "06": {
        fontFamily: "Futura, sans-serif",
        fontSize: 48,
        fontWeight: 300,
        lineHeight: 48
      }
    },
    radius: {
      layerBorder: 12
    }
  },
  ui: {
    button: {
      light: {
        background: {
          active: "rgb(219, 40, 127)",
          default: "rgb(219, 40, 127)",
          hover: "rgb(199, 10, 97)"
        }
      }
    },
    misc: {
      light: {
        focus: {
          default: "rgb(219, 40, 127)"
        }
      }
    }
  }
}), o = new e({
  tokens: {
    background: {
      light: {
        default: "rgb(243, 220, 65)",
        hover: "rgb(248, 234, 148)",
        inverse: "rgb(222, 196, 0)",
        layer01: "white",
        layer02: "rgb(243, 220, 65)"
      }
    },
    body: {
      "compact-productive": {
        fontFamily: '"American Typewriter", serif',
        fontSize: 14,
        fontWeight: 600
      },
      expressive: {
        fontFamily: '"American Typewriter", serif',
        fontWeight: 500
      }
    },
    heading: {
      "03": {
        fontFamily: '"American Typewriter", serif',
        fontSize: 24,
        fontWeight: 400
      },
      "06": {
        fontFamily: '"American Typewriter", serif',
        fontSize: 60,
        fontWeight: 500,
        lineHeight: 60,
        marginBottom: 12
      }
    },
    radius: {
      buttonText: 20,
      layerBorder: 20
    },
    text: {
      dark: {
        primary: {
          default: "black"
        }
      }
    }
  },
  ui: {
    button: {
      light: {
        background: {
          active: "rgb(255 255 255/0.8)",
          default: "white",
          hover: "rgb(248 234 148)"
        }
      }
    },
    misc: {
      light: {
        focus: {
          default: "rgb(0 0 0/0.5)"
        }
      }
    },
    searchParameter: {
      queries: {
        large: { borderRadius: 20 },
        max: { borderRadius: 20 },
        medium: { borderRadius: 20 },
        small: { borderRadius: 20 }
      }
    }
  }
});
export {
  a as BeverlyHills,
  t as Dark,
  i as Default,
  o as Sunny
};
